<div class="flex flex-col">
	<form
		#form="ngForm"
		(ngSubmit)="save(form)"
		class="flex flex-col justify-between overflow-hidden gap-4"
	>
		<app-lender-search-input
			*ngIf="!readonlyFinancialInstitution"
			(onSelected)="onFinancialInstitutionSelected($event)"
		></app-lender-search-input>
		<app-financial-institution-branch-search
			*ngIf="selectedFinancialInstitution"
			[financialInstitution]="selectedFinancialInstitution"
			[autoComplete]="true"
			(onSelectedBranch)="onSelectedBranch($event)"
		>
		</app-financial-institution-branch-search>
		<hr />
		<app-input
			label="Institution Name"
			name="institutionName"
			[submitted]="form.submitted"
			[required]="true"
			disabled
			[(ngModel)]="localBranch.name"
		></app-input>
		<app-input
			label="Institution Number"
			name="InstitutionNumber"
			[required]="true"
			[submitted]="form.submitted"
			[(ngModel)]="localBranch.institutionNumber"
			disabled
		></app-input>
		<app-input
			label="Transit Number"
			name="transitNumber"
			[required]="true"
			[submitted]="form.submitted"
			[(ngModel)]="localBranch.transitNumber"
		></app-input>
		<app-address
			name="Branch Address"
			[address]="localBranch.address"
			(onAddressUpdate)="onAddressUpdate($event)"
			[required]="true"
			[submitted]="form.submitted"
			[enableCountrySelect]="false"
		>
		</app-address>

		<div class="flex justify-between mb-20">
			<ui-button
				*ngIf="localBranch?.id"
				[disabled]="saving"
				label="Delete"
				preset="DANGER"
				(click)="onDeleteLocalBranch()"
			/>
			<ui-button
				[disabled]="saving"
				type="submit"
				[label]="submitButtonText"
			></ui-button>
		</div>
	</form>
</div>
